exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-5bae7d3c] .avatar-uploader .el-upload {\n  width: 1.5625rem;\n  height: 0.833333rem;\n}\n.link[data-v-5bae7d3c] .avatar {\n  width: 1.5625rem;\n  height: 0.833333rem;\n}", ""]);

// exports
